import _extends from "@babel/runtime/helpers/extends";
import { EAffiliateCurrency } from "@devowl-wp/api-real-commerce";
import { Alert, Checkbox, Form } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../../store";
import { _i, __ } from "../../../../utils";
const AccountAffiliateTerms = observer(_ref => {
  let {
    manufacturer,
    formItemAttr = {}
  } = _ref;
  const {
    accountStore: {
      isAffiliate,
      isLoggedIn
    }
  } = useStores();
  return /*#__PURE__*/React.createElement(Form.Item, _extends({
    label: __("Terms and Conditions"),
    required: true
  }, formItemAttr), isAffiliate ? /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have checked your data for validity!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, __("I have checked my data for validity and if my payment details have changed, I have been informed that they will be valid from the 15th of the following month."))) : /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the Terms and Conditions!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read and agree to the {{a}}Affiliate Terms and Conditions of %s{{/a}}.", manufacturer.name), {
    a: /*#__PURE__*/React.createElement("a", {
      href: manufacturer.terms,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), !isLoggedIn && /*#__PURE__*/React.createElement(Form.Item, {
    name: "privacy",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the privacy policy!")
    }]
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read the {{a}}Privacy Policy of %s{{/a}}.", manufacturer.name), {
    a: /*#__PURE__*/React.createElement("a", {
      href: manufacturer.privacy,
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: (_ref2, _ref3) => {
      let {
        affiliate: {
          paymentDetails: prevPd
        }
      } = _ref2;
      let {
        affiliate: {
          paymentDetails: nextPd
        }
      } = _ref3;
      return (prevPd === null || prevPd === void 0 ? void 0 : prevPd.currency) !== (nextPd === null || nextPd === void 0 ? void 0 : nextPd.currency);
    }
  }, _ref4 => {
    let {
      getFieldValue
    } = _ref4;
    const currency = getFieldValue(["affiliate", "paymentDetails", "currency"]);
    return currency !== undefined && currency !== EAffiliateCurrency.EUR && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
      style: {
        marginTop: 15
      },
      message: _i(__("International transfers outside the SEPA area cause additional fees, which will be passed on to you. Your payout amount will be automatically reduced by the {{a}}fees of our money transfer service Wise{{/a}}."), {
        a: /*#__PURE__*/React.createElement("a", {
          href: __(`https://wise.com/gb/pricing/send-money?sourceAmount=500&sourceCcy=EUR&targetCcy={{targetCurrency}}&tab=0`, {
            targetCurrency: currency
          }),
          rel: "noreferrer",
          target: "_blank"
        })
      }),
      type: "info",
      showIcon: true
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Form.Item, {
      name: "feeAgreement",
      valuePropName: "checked",
      rules: [{
        type: "boolean",
        required: true,
        transform: value => value || undefined,
        message: __("Please confirm the fee agreement!")
      }]
    }, /*#__PURE__*/React.createElement(Checkbox, null, __("I agree that fees for payout of my affiliate commissions may be deducted.", manufacturer.name))));
  }));
});
export { AccountAffiliateTerms };